/**
 * @file: 卧柜渲染
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../UIToolkit/index';
import * as RenderCore from './renderCore/index';
import { Watcher } from '../../observe/index';

// 卧柜渲染
function shelfRender(cube: CubeNode): void {
    // 去掉resize的偏移
    RenderCore.clearResizePosition(cube);

    // 渲染层板放置区域宽高
    new Watcher(() => {
        RenderCore.setDropAreaStyle(cube);
    });

    //渲染货架title
    new Watcher(() => {
        RenderCore.setTitleStyle(cube);
    });

    // 最后一个卧柜加标记class
    RenderCore.addFreezerClass(cube);

    // 设置流动边框动画属性
    UIToolkit.setFlowBorderPropertiy(cube, '.shelves-freezer-slot');
}

export default shelfRender;
